module.exports = __webpack_public_path__ + "img/资源库.97ca40c4.png";